// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-wrapper {\n  margin-bottom: 12px;\n}\n.title-wrapper .title {\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n.title-wrapper .title-time {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.title-wrapper .title-date {\n  font-size: 12px;\n  line-height: 16px;\n}\n.title-wrapper .close-button {\n  cursor: pointer;\n  margin-top: 9px;\n  display: flex;\n  border: none;\n  outline: none;\n}\n", ""]);
// Exports
module.exports = exports;
